import React from "react";

// Customizable Area Start
import {
  Box,
  IconButton,
  ListItemText,
  ListItem,
  List,
  Drawer,
  Avatar,
  Button,
  Badge,
} from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { styled } from '@mui/material/styles';
import { bellIcon, bsLogo, msgIcon } from "./assets";
import NavButton from "../../../components/src/NavButton";
import { CommonPopover } from "../../../components/src/ProfileDropDown.web";
import Notifications from "../../../blocks/notifications/src/Notifications.web";
import CustomConfirmationDialog from "../../../components/src/CustomConfirmationDialog.web";

const HeaderWrapper = styled("header")({
  '& *': {
    fontFamily: "Montserrat, sans-serif !important",
    fontWeight: '400',
  },
  "& .iconWrapper": {
    cursor: "pointer",
    minWidth: "auto",
    padding: "5px",
    borderRadius: "50%",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.08)"
    }
  },
  '& .navContainer': {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    height: '80px',
    padding: '0 70px',
    backgroundColor: '#fff',
    '@media (max-width: 1279px)': {
      padding: '0 16px',
    }
  },
  '& .linksContainer': {
    display: 'flex',
    gap: '64px',
    '@media (max-width: 1023px)': {
      display: 'none !important',
    },
    '@media (min-width: 1024px) and (max-width: 1280px)': {
      gap: '30px',
    }
  },
  '& .links': {
    fontSize: '18px !important',
    fontWeight: '500',
    color: '#000 !important',
    lineHeight: '22.94px',
    textDecoration: 'none !important',
    textTransform: 'none',
    '@media (max-width: 415px)': {
      fontSize: '14px !important',
    },
    '@media (min-width: 601px) and (max-width: 1280px)': {
      fontSize: '16px !important',
    }
  },
  '& .loginButton': {
    fontSize: '14px',
    fontWeight: '600',
    width: '150px !important',
    color: '#fff !important',
    lineHeight: '24px !important',
    borderRadius: '32px',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    padding: '10px 39px !important',
    border: '2px solid currentColor !important',
    background: 'linear-gradient(90deg, #8077FF 0%, #652784 60%)',
    '@media (max-width: 1280px)': {
      fontSize: '12px',
    }
  },
  '& .signUpButton': {
    fontSize: '14px',
    fontWeight: '600',
    width: '148px !important',
    color: '#652784 !important',
    lineHeight: '24px !important',
    borderRadius: '32px',
    whiteSpace: 'nowrap',
    textTransform: 'none',
    padding: '8px 37px !important',
    border: '2px solid transparent !important',
    background: 'linear-gradient(to right, white, white), linear-gradient(90deg, #8077FF 0%, #652784 60%)',
    backgroundClip: 'padding-box, border-box',
    backgroundOrigin: 'padding-box, border-box',
    '@media (max-width: 1280px)': {
      fontSize: '12px',
    }
  },
  '& .btnContainer': {
    display: 'flex',
    alignItems: 'center',
    gap: '15px',
    '@media (max-width: 1023px)': {
      display: 'none !important',
    }
  },
  "& .profileContainer": {
    display: 'flex',
    alignItems: 'center',
    gap: '35px'
  },
  '& .hamburgerMenu': {
    display: 'none !important',
    '@media (max-width: 1023px)': {
      display: 'flex !important',
      alignItems: 'center',
      gap: '10px',
    }
  },
  '& .navIcons': {
    width: "32px",
    height: "32px",
  },
});

import NavigationMenuController, {
  Props,
  configJSON,
} from "./NavigationMenuController";

const CustomAvatar = styled(Avatar)({
  width: "44px",
  height: "44px",
  cursor: "pointer"
})
// Customizable Area End
export default class NavigationMenu extends NavigationMenuController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  renderDrawerContent = () => (
    <Box
      role="presentation"
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        height: '100%',
        width: '260px',
      }}
    >
      <List>
        <ListItem>
          <ListItemText>
            <NavButton
              classname={''}
              sx={{
                fontSize: '18px !important',
                fontWeight: '500',
                color: '#000 !important',
                fontFamily: "Montserrat, sans-serif !important",
                lineHeight: '22.94px',
                textDecoration: 'none !important',
                textTransform: 'none',
                justifyContent: 'flex-start',
                padding: '0',
                '@media (max-width: 415px)': {
                  fontSize: '14px !important',
                },
                '@media (min-width: 601px) and (max-width: 1280px)': {
                  fontSize: '16px !important',
                },
              }}
              path="LandingPage"
              dataTestId="home-button"
              onClick={this.handleNavigation}
            >
              Home
            </NavButton>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>
            <NavButton
              classname={''}
              sx={{
                fontSize: '18px !important',
                fontWeight: '500',
                color: '#000 !important',
                fontFamily: "Montserrat, sans-serif !important",
                lineHeight: '22.94px',
                textDecoration: 'none !important',
                textTransform: 'none',
                justifyContent: 'flex-start',
                padding: '0',
                '@media (max-width: 415px)': {
                  fontSize: '14px !important',
                },
                '@media (min-width: 601px) and (max-width: 1280px)': {
                  fontSize: '16px !important',
                }
              }}
              path="Catalogue"
              dataTestId="browser-artists-button"
              onClick={this.handleNavigation}
            >
              Browse Artists
            </NavButton>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>
            <NavButton
              classname={''}
              sx={{
                fontSize: '18px !important',
                fontWeight: '500',
                color: '#000 !important',
                fontFamily: "Montserrat, sans-serif !important",
                lineHeight: '22.94px',
                textDecoration: 'none !important',
                textTransform: 'none',
                justifyContent: 'flex-start',
                padding: '0',
                '@media (max-width: 415px)': {
                  fontSize: '14px !important',
                },
                '@media (min-width: 601px) and (max-width: 1280px)': {
                  fontSize: '16px !important',
                }
              }}
              path="AboutUs"
              dataTestId="about-us-button"
              onClick={this.handleNavigation}
            >
              About Us
            </NavButton>
          </ListItemText>
        </ListItem>
        <ListItem>
          <ListItemText>
            <NavButton
              classname={''}
              sx={{
                fontSize: '18px !important',
                fontWeight: '500',
                color: '#000 !important',
                fontFamily: "Montserrat, sans-serif !important",
                textDecoration: 'none !important',
                textTransform: 'none',
                justifyContent: 'flex-start',
                padding: '0',
                '@media (max-width: 415px)': {
                  fontSize: '14px !important',
                },
                '@media (min-width: 601px) and (max-width: 1280px)': {
                  fontSize: '16px !important',
                }
              }}
              path="Contactus"
              dataTestId="contact-us-button"
              onClick={this.handleNavigation}
            >
              Contact Us
            </NavButton>
          </ListItemText>
        </ListItem>
      </List>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '10px',
          paddingBottom: '16px',
        }}
      >
        {!this.state.isAuthenticated && (
          <>
            <NavButton
              classname={''}
              sx={{
                fontSize: '14px',
                fontWeight: '600',
                width: '140px !important',
                color: '#fff !important',
                fontFamily: "Montserrat, sans-serif !important",
                lineHeight: '24px !important',
                textTransform: 'none !important',
                borderRadius: '32px',
                whiteSpace: 'nowrap',
                padding: '8px 35px !important',
                border: '2px solid currentColor !important',
                background: 'linear-gradient(90deg, #8077FF 0%, #652784 60%)',
                '@media (max-width: 1280px)': {
                  fontSize: '12px',
                },
              }}
              path="EmailAccountLoginBlock"
              dataTestId="login-button"
              onClick={this.handleNavigation}
            >
              Log In
            </NavButton>
            <NavButton
              classname={''}
              sx={{
                fontSize: '14px',
                fontWeight: '600',
                width: '138px !important',
                color: '#652784 !important',
                fontFamily: "Montserrat, sans-serif !important",
                lineHeight: '24px !important',
                textTransform: 'none',
                borderRadius: '32px',
                whiteSpace: 'nowrap',
                padding: '6px 33px !important',
                border: '2px solid transparent !important',
                background:
                  'linear-gradient(to right, white, white), linear-gradient(90deg, #8077FF 0%, #652784 60%)',
                backgroundClip: 'padding-box, border-box',
                backgroundOrigin: 'padding-box, border-box',
                '@media (max-width: 1280px)': {
                  fontSize: '12px',
                },
              }}
              path="EmailAccountRegistration"
              dataTestId="signup-button"
              onClick={this.handleNavigation}
            >
              Sign Up
            </NavButton>
          </>
        )}
      </Box>
    </Box>
  );
  // Customizable Area End

  render() {
    // Customizable Area Start
    const {
      isLoading,
      userProfile,
      menuAnchorEl,
      isLogoutDialog,
      isAuthenticated,
    } = this.state
    return (
      <HeaderWrapper>
        <Box className="navContainer">
          <NavButton
            classname={''}
            path="LandingPage"
            dataTestId="home-button"
            onClick={this.handleNavigation}
          >
            <Box
              component="img"
              src={bsLogo}
              alt="Logo"
              sx={{ cursor: 'pointer' }}
            />
          </NavButton>

          <Box className="linksContainer">
            <NavButton
              classname="links"
              path="LandingPage"
              dataTestId="home-button"
              onClick={this.handleNavigation}
            >
              Home
            </NavButton>
            <NavButton
              classname="links"
              path="Catalogue"
              dataTestId="browser-artists-button"
              onClick={this.handleNavigation}
            >
              Browse Artists
            </NavButton>
            <NavButton
              classname="links"
              path="AboutUs"
              dataTestId="about-us-button"
              onClick={this.handleNavigation}
            >
              About Us
            </NavButton>
            <NavButton
              classname="links"
              path="Contactus"
              dataTestId="contact-us-button"
              onClick={this.handleNavigation}
            >
              Contact Us
            </NavButton>
          </Box>
          <Box className="btnContainer">
            {!isAuthenticated ? (
              <>
                <NavButton
                  classname="loginButton"
                  path="EmailAccountLoginBlock"
                  dataTestId="login-button"
                  onClick={this.handleNavigation}
                >
                  Log In
                </NavButton>
                <NavButton
                  classname="signUpButton"
                  path="EmailAccountRegistration"
                  dataTestId="signup-button"
                  onClick={this.handleNavigation}
                >
                  Sign Up
                </NavButton>
              </>
            ) : (
              <>
                <Box className="iconWrapper" component={Button} onClick={this.handleChatPageRedirection}>
                  <Badge badgeContent={this.customContext.unreadCount} color="error" overlap="circular">
                    <img src={msgIcon} className="navIcons" alt="messages" />
                  </Badge>
                </Box>
                <Box>
                  <Box
                    component={Button}
                    className="iconWrapper"
                    data-test-id="bellIcon"
                    onClick={this.handleBellIconClick}
                  >
                    <Badge
                      overlap="circular"
                      color="error"
                      sx={{
                        "& .MuiBadge-badge": {
                          right: 7,
                          top: 5,
                        }
                      }}
                      badgeContent={this.state.notificationCount}
                    >
                      <img src={bellIcon} alt="messages" className="navIcons" />
                    </Badge>
                  </Box>
                </Box>
                <Box>
                  <CustomAvatar
                    data-test-id="avatarClick"
                    alt={userProfile?.firstName}
                    src={userProfile?.profileImg}
                    onClick={this.handleOpenMenu}
                  />
                </Box>
                <CommonPopover
                  anchorEl={menuAnchorEl}
                  menus={this.MENUS}
                  data-test-id="profileMenu"
                  open={Boolean(menuAnchorEl)}
                  onClose={this.handleCloseMenu}
                />
              </>
            )}
          </Box>
          <Box className="hamburgerMenu">
            {isAuthenticated && (
              <>
                <Box className="iconWrapper" component={Button} onClick={this.handleChatPageRedirection}>
                  <Badge badgeContent={this.customContext.unreadCount} color="error" overlap="circular">
                    <img src={msgIcon} className="navIcons" alt="messages" />
                  </Badge>
                </Box>
                <Box>
                  <Box
                    data-test-id="bellIcon"
                    component={Button}
                    className="iconWrapper"
                    onClick={this.handleBellIconClick}
                  >
                    <Badge
                      color="error"
                      badgeContent={this.state.notificationCount}
                      overlap="circular"
                      sx={{
                        "& .MuiBadge-badge": {
                          top: 5,
                          right: 7,
                        }
                      }}
                    >
                      <img src={bellIcon} className="navIcons" alt="messages" />
                    </Badge>
                  </Box>
                </Box>
                <Box>
                  <CustomAvatar
                    data-test-id="avatarClick"
                    src={userProfile?.profileImg}
                    alt={userProfile?.firstName}
                    onClick={this.handleOpenMenu}
                  />
                </Box>
              </>
            )}
            <IconButton
              onClick={this.toggleDrawer}
              aria-label="menu"
              data-test-id="btnToggleDraw"
            >
              <MenuIcon />
            </IconButton>
            <Drawer
              anchor="right"
              open={this.state.webDrawer}
              onClose={this.toggleDrawer}
            >
              {this.renderDrawerContent()}
            </Drawer>
          </Box>
        </Box>
        <CustomConfirmationDialog
          data-test-id="confirmation-modal"
          isOpen={isLogoutDialog}
          title={configJSON.logout}
          isActionLoading={isLoading}
          subTitle={configJSON.logoutDescription}
          actionBtnTitle={configJSON.logoutText}
          handleAction={this.handleLogout}
          handleClose={this.closeLogoutDialog}
        />
        {isAuthenticated && (
          <Notifications
            id="notifications"
            notificationsPopupId="notifications-popup"
            data-test-id="notificationsPopover"
            open={Boolean(this.state.anchorEl)}
            anchorEl={this.state.anchorEl}
            navigation={this.props.navigation}
            unreadCount={this.state.notificationCount}
            onClose={this.handleNotificationPopupClose}
            setUnreadCount={this.updateUnreadNotificationCount}
          />
        )}
      </HeaderWrapper>
    );
    // Customizable Area End
  }
}

// Customizable Area Start
// Customizable Area End
